export default __webpack_public_path__ + "static/media/home-tile.00ea86d0.png";